import PropTypes from 'prop-types';

const displayName = 'SitePolicy';
const propTypes = {};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
